import React,{useState,useCallback,useRef} from 'react';
import {FaCheckDouble} from 'react-icons/fa';
import {IoVolumeHigh} from 'react-icons/io5';

import {Row,Col} from 'react-bootstrap';
import {RCard} from '@putil-view/item.r-card';
import {RAjax} from '@putil-view/request.r-ajax';
import {SysPath} from 'SysContext';
import {RIconText} from '@putil-view/item.r-icon-text';
import {QrMatchCamera,QrMatchTable,QrMatchCameraText} from './components';
import {isMobile, isIOS} from 'react-device-detect';
import 'css/qr-match.css';
import audio from 'main/audio/match.mp3';
const QrMatch = () => {
	const uuid = useRef('');
	const tableRef= useRef();
	const beepRef = useRef(new Audio(audio));
	const [state, setState] = useState({stage:"FINDING_QR",scanStatus:'',scanCount:0,type:null});
	const handleScanResult = useCallback((result) =>{
		if(result  && result.status && result.text){
			var status = result.status;
			var text = result.text;
			var type = result.type;
			var newScanCount = (status === 'Found'? state.scanCount + 1 : state.scanCount);
			var stage = "FINDING_QR";
			if(status === 'Found' && newScanCount  > 1 && state.scanStatus === "Found" && text === state.text && type !== state.type){
					status = "Matched";
					stage = "UPLOAD_MATCH_RECORD"; //Upload match record to system
					beepRef.current.play();
					if(navigator){
						navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
						if (navigator.vibrate) {
							// vibration API supported
							navigator.vibrate(1000);
						}
					}
			}
			tableRef.current.reset();
			setState(prevState =>{ return{...prevState , ...{stage:stage, scanCount:newScanCount, scanStatus:status, text:text, type:type}}});
		}
	},[state.scanCount, state.scanStatus, state.text, state.type])

	const handleScan = useCallback(qr => {
		if (qr) { //Only validating qr code when stage is 'FINDING_QR' and qr code is found.

				setState(prevState =>{
						if(prevState.stage === 'FINDING_QR'){
							uuid.current = qr;
							return{...prevState , ...{stage:"REQUEST_UUID"}};
						}
						else {
							return prevState;
						}
					}
				);
		}
	},[])

	const stage = state.stage;
	const scanCount = state.scanCount;
	const scanStatus = state.scanStatus;
	const type = state.type;
	const text = state.text;

	return(
		<Row className="mt-6 w-100 pl-0 pr-0 pt-4 align-self-start">
			<Col lg={isMobile?12:6} md={12} sm={12} xs={12} xl={isMobile?12:6} >
					{!isMobile &&
						<>
							<QrMatchCamera  handleScan={handleScan} style={{height: '60vh',width: '60vh',display:'flex',justifyContent: 'center',objectFit: 'cover'}}/>
							<QrMatchCameraText scanStatus={scanStatus} type={type} text={text}/>
						</>
				}
			</Col>
			<Col lg={isMobile?12:6} md={12} sm={12} xs={12} xl={isMobile?12:6} className="pl-0 pr-0">
				<RCard
					title= {
						<>
						<RIconText variant="lg">
							{isIOS ?
								<IoVolumeHigh onClick={()=>{beepRef.current.play()}}/>
								:
								<FaCheckDouble/>
							}
							<span>Match Locker QR Code </span>

						</RIconText>

						</>
					}
				>
					{isMobile &&
							<>

								<QrMatchCamera handleScan={handleScan} style={{height: '40vh',width: '40vh',display:'flex',justifyContent: 'center',objectFit: 'cover'}} />
								<QrMatchCameraText scanStatus={scanStatus} type={type} text={text}/>
							</>
					}
					<QrMatchTable ref={tableRef} scanStatus={scanStatus} scanCount={scanCount} handleScan={handleScan}/>
					{stage === "REQUEST_UUID" &&
						<RAjax requestOptions={{
									method: 'get',
									withCredentials: true,
									url: SysPath.getLockerUrl + "?uuid="+uuid.current
								}}
							handleResponse={handleScanResult}
						/>
					}
					{stage === "UPLOAD_MATCH_RECORD" &&
						<RAjax requestOptions={{
									method: 'post',
									withCredentials: true,
									url: SysPath.addMatchRecordUrl,
									data:{text:text}
								}}
							handleResponse={()=>{setState(prevState =>{ return{...prevState , ...{stage:"FINDING_QR"}}})}}
						/>
					}
				</RCard>
			</Col>
		</Row>
	);
}


export default QrMatch;
